module.exports = __webpack_public_path__ + "img/icon.aafaf7fd.png";